export default __webpack_public_path__ + "static/media/Flag_of_Niue.87e4eacb.svg";